import React, { Component } from 'react';
import {
  withRouter,
} from 'react-router-dom';
import {
  Nav,
  NavItem,
  Navbar
} from 'react-bootstrap';
import AWS from 'aws-sdk';
import { CognitoUserPool, } from 'amazon-cognito-identity-js';
import Routes from './Routes';
import RouteNavItem from './components/RouteNavItem';
import config from './config.js';
import './App.css';
import { Logo } from './Utils';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      userToken: null,
      navContext: 'collaborator',
      isLoadingUserToken: true,
    };
  }

  async componentDidMount() {
    const currentUser = this.getCurrentUser();

    if (currentUser === null) {
      this.setState({isLoadingUserToken: false});
      return;
    }

    try {
      const userToken = await this.getUserToken(currentUser);
      this.updateUserToken(userToken);
    }
    catch(e) {
      alert(e);
    }

    this.setState({isLoadingUserToken: false});
  }

  updateUserToken = (userToken) => {
    this.setState({
      userToken: userToken
    });
  }

  getCurrentUser() {
    const userPool = new CognitoUserPool({
      UserPoolId: config.cognito.USER_POOL_ID,
      ClientId: config.cognito.APP_CLIENT_ID
    });
    return userPool.getCurrentUser();
  }

  getUserToken(currentUser) {
    return new Promise((resolve, reject) => {
      currentUser.getSession(function(err, session) {
        if (err) {
            reject(err);
            return;
        }
        resolve(session.getIdToken().getJwtToken());
      });
    });
  }

  handleNavLink = (type, event) => {
    event.preventDefault();
    this.setState({ navContext: type });
    this.props.history.push(event.currentTarget.getAttribute('href'));
  }

  handleLogin = (event) => {
    event.preventDefault();
    this.props.history.push(event.currentTarget.getAttribute('href'));
  }

  handleLogout = (event) => {
    const currentUser = this.getCurrentUser();

    if (currentUser !== null) {
      currentUser.signOut();
    }

    if (AWS.config.credentials) {
      AWS.config.credentials.clearCachedId();
    }

    this.updateUserToken(null);

    this.props.history.push('/login');
  }

  render() {
    const childProps = {
      userToken: this.state.userToken,
      updateUserToken: this.updateUserToken,
    };

    const contextMap = new Map();
    contextMap.set('collaborator', {toType: 'media-mgmt', href: '/media-mgmt', text: 'Manage Post Media'});
    contextMap.set('media-mgmt', {toType: 'collaborator', href: '/', text: 'Manage Collaborators'});

    const currNavContext = contextMap.get(this.state.navContext)
    const loggedInArr = [ <RouteNavItem key={1} onClick={(e) => this.handleNavLink(currNavContext.toType, e)} href={currNavContext.href}>{currNavContext.text}</RouteNavItem>, <NavItem key={2} onClick={this.handleLogout}>Logout</NavItem> ]
    const loggedOutArr = <RouteNavItem key={3} onClick={this.handleLogin} href={currNavContext.href}>Login</RouteNavItem>

    return ! this.state.isLoadingUserToken
    &&
    (
      <div className="App container">
        <Navbar fluid collapseOnSelect>
          <Navbar.Header>
            <Navbar.Brand>
             <Logo />
            </Navbar.Brand>
            <Navbar.Toggle />
          </Navbar.Header>
          <Navbar.Collapse>
            <Nav pullRight>
                { this.state.userToken
                ? loggedInArr
                : loggedOutArr }
            </Nav>
          </Navbar.Collapse>
        </Navbar>
        <Routes childProps={childProps} />
      </div>
    );
  }

}

export default withRouter(App);
// export default App;



// WEBPACK FOOTER //
// ./src/App.js